import { HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, of, tap } from 'rxjs';

export function isUnauthorizedError(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 401;
}

export function trackUnauthorizedLoad<T>(
  key: string,
  pendingKeys: Set<string>,
  empty: T,
) {
  return (source: Observable<T>) =>
    source.pipe(
      tap(() => pendingKeys.delete(key)),
      catchError((error: unknown) => {
        if (isUnauthorizedError(error)) {
          pendingKeys.add(key);
        }
        return of(empty);
      }),
    );
}
